export * from './HotelsLink';
